import { render, staticRenderFns } from "./AppCalendarV2.vue?vue&type=template&id=521717c8&scoped=true&"
import script from "./AppCalendarV2.vue?vue&type=script&lang=ts&"
export * from "./AppCalendarV2.vue?vue&type=script&lang=ts&"
import style0 from "./AppCalendarV2.vue?vue&type=style&index=0&id=521717c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521717c8",
  null
  
)

export default component.exports